const Review = {
  Refuse: 'refuse',
  Agree: 'agree',
  Reviewing: 'reviewing'
}
export default Review
